import * as React from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'

import { clearErrorMessage, deleteGroup, selectGroupsStatus } from 'slices/groupsSlice'

import { CustomModal } from 'components/common'

type Props = {
  isOpen: boolean
  workspaceId: number
  groupId: number | undefined
  onSuccess: () => void
  onCancel: () => void
}

const GroupDelete: React.FC<Props> = ({ isOpen, workspaceId, groupId, onSuccess, onCancel }) => {
  const [modalErrorMessage, setModalErrorMessage] = React.useState<string | undefined>(undefined)
  const [submitted, setSubmitted] = React.useState(false)
  const { isRequesting, errorMessage } = useSelector(selectGroupsStatus, shallowEqual)
  const dispatch = useDispatch()

  const handleCancelClick = () => {
    setModalErrorMessage(undefined)
    onCancel()
  }

  const handleDeleteClick = () => {
    if (groupId) {
      setSubmitted(true)
      dispatch(deleteGroup(workspaceId, groupId))
    }
  }

  React.useEffect(() => {
    if (!submitted || isRequesting) {
      return
    }
    if (errorMessage === '') {
      onSuccess()
    } else {
      setModalErrorMessage('削除できませんでした。')
      dispatch(clearErrorMessage())
    }
    setSubmitted(false)
  }, [submitted, isRequesting, errorMessage, dispatch, onSuccess])

  return (
    <CustomModal
      isOpen={isOpen}
      title="グループの削除"
      approveColor="danger"
      approveLabel="削除"
      errorMessage={modalErrorMessage}
      onCancel={handleCancelClick}
      onApprove={handleDeleteClick}
      onHideNotification={() => setModalErrorMessage(undefined)}
    >
      <div className="pb-4">このグループを本当に削除しますか？この操作は取り消せません。</div>
    </CustomModal>
  )
}

export default GroupDelete
